import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        translations: {
          safetyOrderRearGarage:
            "Sicherheit und Ordnung in der Wohnmobil-Heckgarage",
          cargoSecurityRearGarage:
            "Ladungssicherung in der Wohnmobil-Heckgarage",
          noProblemWithAllsafe: "Kein Problem mit allsafe!",
          customCargoSecuritySolutions:
            "Wir bieten individuelle Lösungen um die Ladung in der Heckgarage professionell zu sichern. Egal ob es sich um ein neues Fahrzeug handelt oder ob Sie die Heckgarage an einem bestehenden Fahrzeug nachrüsten wollen. Sprechen Sie uns an und gemeinsam finden wir eine passende Lösung für Ihren Anwendungsfall.",
          exploreMoreRear: "Werfen Sie einen Blick auf unseren",
          rearGarageFlyer: "Heckgaragen-Flyer.",
          ourProductRange: "Unser Sortiment",
          airlineRails: "Airline Schienen",
          airlineRailBaseInfiniteOptions:
            "Die Airline-Schiene ist die Basis für einen Baukasten mit fast unendlich vielen Möglichkeiten. Sie bietet eine hohe Belastbarkeit bei gleichzeitig geringem Gewicht, einfacher Reinigung und ergonomischer Gestaltung.",
          allsafeOriginalAirlineRails:
            "Achten Sie deshalb auf originale allsafe Airline-Schienen: Nur im allsafe-System passt alles perfekt zueinander und die Komponenten sind nach höchsten Automotive-Standards entwickelt und gefertigt.",
          allsafeExteriorRailEce324:
            "Die allsafe Exterior-Schiene erfüllt derzeit als einzige Airline-Schiene im Markt die Anforderungen nach ECE 324 R26 und ist dank Eloxal-Oberfläche für die Montage außen am Fahrzeug geeignet.",
          weight300gPerMeter:
            "Mit einem Gewicht von gerade mal 300 g pro Meter wiegt sie nur etwa die Hälfte einer original Airline-Schiene.",
          fittings: "Fittinge",
          airlineRailLightSemicylindrical:
            "(1) Airline-Schiene light, halbrund",
          airlineRailSpecialExterior:
            "(2) Airline-Schiene Spezial, Exterior-Schiene",
          miniAirlineRail: "(3) Mini Airline-Schiene",
          kerlButlerPerformsAsExpected:
            "KERL Butler macht seinem Namen alle Ehre: Er dient Ihnen bei fast jeder Transportaufgabe und sorgt stets für Ordnung. Er verbiegt und verdreht sich, genau so, wie Sie es wünschen. Und wenn Sie ihn einmal nicht benötigen, ist er mit einem Handgriff aus der Airline-Schiene entnommen.",
          kerlCaravanToolFreeInstallation:
            "Der KERL Caravan wird ohne Werkzeug in die Airline-Schiene eingesetzt und verklemmt. Kunststoffboxen, Fahrradträger und verschiedene Behälter können mit einem Handgriff in der Airline-Schiene fixiert werden. Ideal für alles, was schnell ein- und wieder ausgebaut wird.",
          kerlJimM8: "KERL JIM M8",
          kerlJimM8InternalThread:
            "Ein Innengewinde überall dort, wo Sie es brauchen. Und wenn Sie es morgen an einer anderen Stelle brauchen? Dann schieben Sie den KERL JIM M8 einfach dort hin. Oder Sie nehmen ihn mit einem Handgriff aus der Airline-Schiene heraus. KERL JIM M8 klappert nicht, fällt nicht un-beabsichtigt aus der Airline-Schiene heraus und steht nicht hervor. Ein kleines Befestigungs-Genie!",
          gurte: "Gurte",
          kerl500ClampLockStrap: "KERL 500 und Klemmschlossgurt",
          clampLockStrapsWithKerl500:
            "Klemmschlossgurte mit KERL-500-Beschlag sind die Universalgenies der Ladungssicherung. Mit ihnen können Sie fast alles schnell und einfach sichern: Egal ob Skiausrüstung, Campingmöbel oder Transportboxen – selbst Grills finden mit ihnen sicheren Halt während der Fahrt.",
          kerl500AvailableIndividually:
            "Den KERL 500 gibt es natürlich auch lose. Warum wir den KERL 500 genannt haben? Vielleicht auch, weil er Sie bei bestimmt 500 verschiedenen Ladungssicherungs-Aufgaben unterstützt.",
          kerl500V2aRustResistant:
            "Für die Exterior-Schiene und bei allen Einsätzen außen am Fahrzeug empfehlen wir den rostfreien KERL 500 V2A. Selbstverständlich passen KERL 500 und KERL 500 V2A in alle allsafe Airline-Schienen.",
          lockingRods: "Sperrstangen",
          kim4x4Airline: "KIM 4x4 Airline",
          availableFromJanuary2024: "Verfügbar ab Januar 2024!",
          kim4x4DualPurposeLockingRod:
            "KIM 4x4 ist doppelt praktisch: Diese Sperrstange sichert zum einen Ihre wertvolle Ladung, zum anderen erweitern die serienmäßigen Airline-Schienen die Stau- und Befestigungsmöglichkeiten in Ihrer Heckgarage.",
          cleverDetailsTwistLockOperatingStrap:
            "Pfiffige Details wie die Verdrehsicherung und der Bediengurt erleichtern das Handling – und wenn KIM 4x4 einmal nicht benötigt wird, kann sie ganz einfach entnommen und an anderer Stelle eingesetzt werden.",
          contactNow: "Jetzt kontaktieren.",
          togetherWeFindSolution:
            "Gemeinsam finden wir eine Lösung zur Sicherung Ihrer Ladung.",
          privacyStatement: "Datenschutzerklärung",
          cookieSettings: "Cookie-Einstellungen",
          imprint: "Impressum",
          AVD: "AVD",
        },
      },
      en: {
        translations: {
          safetyOrderRearGarage:
            "Safety and order for your motorhome rear garage",
          cargoSecurityRearGarage:
            "Load securing for rear motorhome garages",
          noProblemWithAllsafe: "No problem with the allsafe system!",
          customCargoSecuritySolutions:
            "We supply individual solutions to secure load in rear garages. These professional components fit to factory new vehicles as well as to used vehicles. Please do not hesitate to ask us for supporting you in finding the perfect solution for your vehicle!",
          exploreMoreRear: "Find more in our rear",
          rearGarageFlyer: "garage catalogue",
          ourProductRange: "Product range",
          airlineRails: "Airline tracks",
          airlineRailBaseInfiniteOptions:
            "The airline track is the base for a huge load securing kit with almost infinity possibilities: high strength, a low mass, easy to clean and ergonomic design make the airline track uniqe.",
          allsafeExteriorRailEce324:
            "The allsafe exterieur airline track is untill now the only airline track available that complies with ECE 324 R26. Its black anodized surface makes it suitable for exterieur applications.",
          weight300gPerMeter:
            "With a weight of just 300 g per meter, it weighs only about half as much as an original airline track.",
          airlineRailLightSemicylindrical: "(1) Airline track semi circular",
          airlineRailSpecialExterior: "(2) Exterieur airline track ",
          miniAirlineRail: "(3) Mini Airline-Tracks",
          kerlCaravanToolFreeInstallation:
            "KERL Caravan easy to fit without any tools. It just clamps into the airline track to assemble almost anything into your airline track, e.g. various boxes or bicycle racks. Easily assemble and disassemble your devices with one hand!",
          allsafeOriginalAirlineRails:
            "Make sure to only chose the original allsafe airline tracks: we guarantee 100 % compatibility with all components from the allsafe system. Each component is designed and manufactured as per highest automotive standards.",
          kerlButlerPerformsAsExpected:
            "KERL Butler is a must-have in every camping caravan: It helps you to keep almost everything in place. It turns and twists as you like - as flexible as your requirements! And if you don't need your Butler at the moment: just remove it from your airline track within a second.",
          fittings: "Fittings",
          kerlJimM8: "KERL JIM M8",
          kerlJimM8InternalThread:
            "KERL JIM M8 supplies a female thread everywhere you require one. But what if you need it somewhere else? Just slide KERL JIM M8 there. Or remove it from your airline track with one hand. KERL JIM M8 offers a non-rattle-design and a smart clamping system to not fall of the airline track during assembly process.",
          gurte: "Belts",
          kerl500ClampLockStrap: "KERL 500 and cam buckle strap",
          clampLockStrapsWithKerl500:
            "Cam buckle straps with KERL 500 are little geniusses for load securing. They support various load securing jobs: Ski equipment, outdoor furniture, universal boxes - even barbecue grills can be easily and safely secured.",
          kerl500AvailableIndividually:
            "KERL 500 is also available seperately. To support at least 500 different load securing tasks - maybe this is one reason why we call it KERL 500.",
          kerl500V2aRustResistant:
            "For all exterieur applications we recommend the inox-Version of KERL 500. We guarantee a 100 % perfect fit with all original allsafe airline tracks for all KERL 500.",
          lockingRods: "Shoring bars",
          kim4x4Airline: "KIM 4x4 Airline",
          availableFromJanuary2024: "Available from January 2024!",
          kim4x4DualPurposeLockingRod:
            "Make it double with KIM 4x4: This shoring bar is not only a shoring bar but also an airline track! This gives you additional load securing options in your rear garage.",
          cleverDetailsTwistLockOperatingStrap:
            "Smart details support the easy handling. And just in case you sometimes don't need your KIM 4x4: Just remove it from the airline track and store it somewhere else.",
          contactNow: "Contact us.",
          togetherWeFindSolution:
            "Together we will find a solution for your load securing project.",
          privacyStatement: "Privacy disclaimer",
          cookieSettings: "Cookie settings",
          imprint: "Imprint",
          AVD: "GCS",
        },
      },
      fr: {
        translations: {
          safetyOrderRearGarage:
            "Ordre et sécurité dans la soute du camping-car",
          cargoSecurityRearGarage:
            "Sécurisation du chargement dans la soute du camping-car",
          noProblemWithAllsafe: "Pas de problème avec allsafe!",
          customCargoSecuritySolutions:
            "Nous proposons des solutions individuelles pour sécuriser et organiser de manière professionnelle le chargement dans la soute du camping-car. Qu'il s'agisse d'un nouveau véhicule ou que vous souhaitiez équiper la soute d'un véhicule existant. Contactez-nous et nous trouverons ensemble une solution adaptée à votre cas d'application.",
          exploreMoreRear:
            "Jetez un coup d'œil à notre dépliant sur la soute du camping-car.",
          rearGarageFlyer: "Voir le dépliant.",
          ourProductRange: "Notre assortiment",
          airlineRails: "Rails aéro",
          airlineRailBaseInfiniteOptions:
            "Le rail aéro est la base d‘un système modulaire offrant un nombre presque infini de possibilités. Il offre une grande capacité de charge tout en étant légère, facile à nettoyer et ergonomique.",
          allsafeOriginalAirlineRails:
            "Veillez donc à utiliser des rails aéro d‘origine allsafe: Ce n‘est que dans le système allsafe que toutes les pièces s‘adaptent parfaitement les unes aux autres. Et les composants sont développés et fabriqués selon les normes automobiles les plus strictes.",
          allsafeExteriorRailEce324:
            "Le rail Exterior d‘allsafe est actuellement le seul rail du marché à répondre aux exigences de la norme ECE 324 R26 et, grâce à sa surface anodisé, adapté au montage à l‘extérieur du véhicule.",
          weight300gPerMeter:
            "Avec un poids d'à peine 300 g par mètre, il ne pèse que la moitié d'un rail original de compagnie aérienne.",
          airlineRailLightSemicylindrical:
            "(1) Rail aéro léger, semi-circulaire",
          airlineRailSpecialExterior: "(2) Rail aéro spécial, Rail-Exterior",
          miniAirlineRail: "(3) Rail aéro mini",
          kerlCaravanToolFreeInstallation:
            "Le KERL Caravan s‘insère et se bloque sans outil dans le rail aéro. Les boîtes en plastique, les porte-vélos et les différents conteneurs peuvent être fixés en un tour de main dans le rail aéro. Idéal pour tout ce qui doit être monté et démonté rapidement.",
          kerlButlerPerformsAsExpected:
            "KERL Butler fait honneur à son nom : il est à votre service pour presque toutes les tâches de transport et il veille toujours à l‘ordre. Il se plie et se tord, exactement comme vous le souhaitez. Et si vous n‘en avez pas besoin, il peut être retiré du rail aéro en un tour de main.",
          fittings: "Fittings",
          kerlJimM8: "KERL JIM M8",
          kerlJimM8InternalThread:
            "Un filetage intérieur partout où vous en avez besoin. Et si demain vous en avez besoin ailleurs ? Alors il vous suffit de glisser le KERL JIM M8 à cet endroit. Ou vous le retirez du rail aéro en un tour de main. Le KERL JIM M8 ne fait pas de bruit, ne tombe pas accidentellement hors du rail aéro et ne dépasse pas. Un petit génie de la fixation !",
          gurte: "Sangles",
          kerl500ClampLockStrap: "Sangle de serrage",
          clampLockStrapsWithKerl500:
            "Les sangles de serrage avec embout KERL 500 sont les génies universels de l‘arrimage des charges.",
          kerl500AvailableIndividually:
            "Elles permettent de sécuriser presque tout rapidement et facilement : qu‘il s‘agisse d‘équipement de ski, de meubles de camping ou de caisses de transport, même les barbecues sont bien maintenus pendant le trajet.",
          kerl500V2aRustResistant:
            "Pour le rail Exterior et pour toutes les utilisations à l‘extérieur du véhicule, nous recommandons le KERL 500 en acier inoxydable. Bien entendu, le KERL 500 et KERL 500 inoxydable s‘adaptent à tous les rails airline d‘allsafe.",
          lockingRods: "Barres d’arrimage",
          kim4x4Airline: "KIM 4x4 Airline",
          availableFromJanuary2024: "Disponible à partir de janvier 2024 !",
          kim4x4DualPurposeLockingRod:
            "KIM 4x4 Airline est doublement pratique : d‘une part, cette barre de blocage sécurise votre précieux chargement et, d‘autre part, les rails aéro de série élargissent les possibilités de rangement et de fixation dans votre soute.",
          cleverDetailsTwistLockOperatingStrap:
            "Des détails astucieux comme le dispositif anti-torsion et la sangle facilitent la manipulation. Et si la KIM 4x4 n‘est pas utilisée, elle peut être retirée très facilement et utilisée ailleurs.",
          contactNow: "Contactez-nous maintenant !",
          togetherWeFindSolution:
            "Ensemble, nous trouverons une solution pour sécuriser votre chargement. ",
          privacyStatement: "Déclaration de confidentialité",
          cookieSettings: "Paramètres des cookies",
          imprint: "Imprimer",
          AVD: "CGV",
        },
      },
    },
    fallbackLng: "de",
    lng: "de",
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
